import { dateFormat } from '@/configs/dateFormat';
import dayjs, { Dayjs } from 'dayjs';

const formatNumber = (value: number, degit?: number): string => {
  return (
    (value &&
      value.toLocaleString(undefined, {
        minimumFractionDigits: degit ?? 0,
        maximumFractionDigits: 2,
      })) ||
    ''
  );
};

const formatDate = (date: string | Date | Dayjs): string => {
  const parsedDate = date && dayjs(date || undefined).format(dateFormat);
  if (parsedDate === 'Invalid Date') return date as string;
  return parsedDate ?? '';
};

const docTypeInvoice = (data: string): string => {
  switch (data) {
    case 'INV':
      return 'ใบกำกับภาษี';
    case 'CN':
      return 'ใบลดหนี้';
    case 'DN':
      return 'ใบเพิ่มหนี้';
    default:
      return 'ทั้งหมด';
  }
};

const docTypeReceipt = (data: string): string => {
  switch (data) {
    case 'RC':
      return 'ใบเสร็จรับเงิน';
    default:
      return 'ทั้งหมด';
  }
};

export { formatNumber, formatDate, docTypeInvoice, docTypeReceipt };
